// extracted by mini-css-extract-plugin
export var card = "offers-module--card--a9b61";
export var english = "offers-module--english--41786";
export var info = "offers-module--info--d9b1f";
export var offers = "offers-module--offers--a2264";
export var teens = "offers-module--teens--6e0bb";
export var teens__card = "offers-module--teens__card--4830c";
export var wrap = "offers-module--wrap--f0aff";